import { useRbac } from "./RbacContext";

export function useCanAccess() {
  const { canAccess, isLoading, error } = useRbac();
  return { canAccess, isLoading, error };
}
